document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('home')) {
        let swiper = new Swiper('.swiper-home', {
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        let videoElement = document.getElementById('home-video');

        videoElement.addEventListener('play', function () {
            if (swiper) {
                swiper.autoplay.stop();
            }
        });
        videoElement.addEventListener('ended', function() {
            if (swiper) {
                swiper.slideNext();
            }
        })
    }

    if (document.body.classList.contains('page-template-sostenibilidad') || document.body.classList.contains('page-template-empresa-saludable')) {
        var swiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    if (document.body.classList.contains('ocasion-template-default')) {
        var pasafotosSwiper = new Swiper('.pasafotos-swiper-container', {
            slidesPerView: 'auto',
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
              nextEl: '.pasafotos-swiper-container .swiper-button-next',
              prevEl: '.pasafotos-swiper-container .swiper-button-prev',
              clickable: true,
            },
        });
        var gallerySwiper = new Swiper('.gallery-swiper-container', {
            slidesPerView: 'auto',
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                clickable: true,
            },
        });
    }

    if (document.body.classList.contains('page-template-soluciones')) {
        var agriculturaSwiper = new Swiper('.agricultura-swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: '.agricultura-swiper-container .swiper-button-next',
                prevEl: '.agricultura-swiper-container .swiper-button-prev',
            },
            autoplay: {
                delay: 5000,
            },
        });

        var construccionSwiper = new Swiper('.construccion-swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: '.construccion-swiper-container .swiper-button-next',
                prevEl: '.construccion-swiper-container .swiper-button-prev',
            },
            autoplay: {
                delay: 5500,
            },
        });

        var transporteSwiper = new Swiper('.transporte-swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: '.transporte-swiper-container .swiper-button-next',
                prevEl: '.transporte-swiper-container .swiper-button-prev',
            },
            autoplay: {
                delay: 6000,
            },
        });


        var industriaSwiper = new Swiper('.industria-swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: '.industria-swiper-container .swiper-button-next',
                prevEl: '.industria-swiper-container .swiper-button-prev',
            },
            autoplay: {
                delay: 6500,
            },
            speed: 600,
        });

        var alquilerSwiper = new Swiper('.alquiler-swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: '.alquiler-swiper-container .swiper-button-next',
                prevEl: '.alquiler-swiper-container .swiper-button-prev',
            },
            autoplay: {
                delay: 7000,
            },
        });
    }
});